import React, { Component, PropTypes } from 'react';
import { call, cond, equals, ifElse, either, isEmpty, isNil, not } from 'ramda';
import SelectCompanyTypeContainer from './select-company-type/select-company-type-container';
import AcctCreationReasonContainer from './acct-creation-reason/acct-creation-reason-container';
import CompanyOperation from './supplier/company-operations';
import AcctForm from './form/form-container';
import SignUpConfirmation from './confirmation/confirm-sign-up.jsx';

const isNilOrEmpty = either(isEmpty, isNil);

class SignUp extends Component {
  render() {
    const {
      goToStep,
      signup,
      step,
      onUserInput,
      checkOneCompanyType,
      uncheckOneCompanyType,
      dispatchedUpdateProps,
      checkCompanyName,
      submitSignUpAction,
    } = this.props;

    const sharedProps = {
      goToStep,
      onUserInput,
      checkOneCompanyType,
      uncheckOneCompanyType,
      dispatchedUpdateProps,
      goToSignUpForm: () => goToStep(4),
      backButtonFunc: () => call(ifElse(
        equals(true),
          () => call(ifElse(
            equals(3),
              () => goToStep(step - 2),
            () => goToStep(step - 1)
          ), signup.step),
        () => goToStep(step - 1)
      ), Boolean(signup.MMCompanyToView)),
      ...signup,
    };

    const propsForSelectCompanyType = {
      componentIndex: 1,
      goToAcctCreactionReason: () => {
        if (not(isNilOrEmpty(signup.MMCompanyToView))) {
          if (signup.selectedCompanyType === 'dmo' || signup.selectedCompanyType === 'buyer' || signup.selectedCompanyType === 'other') return goToStep(4);
          return goToStep(3);
        }
        return goToStep(2);
      },
    };

    const propsForAcctCreationReason = {
      componentIndex: 2,
      backFunc: () => goToStep(1),
      acctCreationReason: signup.acctCreationReason,
      goToAccomNonAccomPage: () => goToStep(3),
    };

    const propsForAccomNonAccom = {
      componentIndex: 3,
    };

    const propsForForm = {
      componentIndex: 4,
      checkCompanyName,
      submitSignUpAction,
      goToConfirmationPage: () => goToStep(5),
    };

    const propsForConfirmation = {
      componentIndex: 5,
    };

    return (
      <div style={{ top: '75px', position: 'relative', paddingBottom: '100px' }}>
        <div className="Grid">
          <div className="Grid-cell Grid--center">
            {
              call(cond([
                [equals(1), () => (<SelectCompanyTypeContainer
                  {...propsForSelectCompanyType}
                  {...sharedProps}
                  {...signup}
                />)],
                [equals(2), () => (<AcctCreationReasonContainer
                  {...propsForAcctCreationReason}
                  {...sharedProps}
                  {...signup}
                />)],
                [equals(3), () => (<CompanyOperation
                  {...propsForAccomNonAccom}
                  {...sharedProps}
                  {...signup}
                />)],
                [equals(4), () => (<AcctForm
                  {...propsForForm}
                  {...sharedProps}
                  {...signup}
                />)],
                [equals(5), () => (<SignUpConfirmation
                  {...propsForConfirmation}
                  {...sharedProps}
                  {...signup}
                />)],
              ]), step)
            }
          </div>
        </div>
      </div>
    );
  }
}

SignUp.propTypes = {
  checkCompanyName: PropTypes.func,
  checkOneCompanyType: PropTypes.func,
  dispatchedUpdateProps: PropTypes.func,
  goToStep: PropTypes.func,
  location: PropTypes.object,
  onUserInput: PropTypes.func,
  signup: PropTypes.object,
  step: PropTypes.number,
  submitSignUpAction: PropTypes.func,
  uncheckOneCompanyType: PropTypes.func,
};

export default SignUp;



// WEBPACK FOOTER //
// ./src/app/components/signup/signup.jsx